export const isServerSideRender: boolean = typeof window === "undefined";
